import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'wilson-timeline-modal-loader',
  templateUrl: './timeline-modal-loader.component.html',
  styleUrls: ['./timeline-modal-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FontAwesomeModule],
})
export class TimelineModalLoaderComponent {
  checkIcon = faCheck;
}
